/* eslint-disable global-require */
import { Call } from "@twilio/voice-sdk";
import { colors } from "@zapalacorp/tokens";

import packageJson from "../package.json";
import { Option } from "./models/option";
import { Edge } from "./types";
import {
  LocationStatus,
  Months,
  OrderStatus,
  ShipmentTrackingStatus,
  StorageStatus,
  TransshipmentStatus,
  UserTypes,
  ResourceName,
  TaskType,
  ReportName,
} from "./util/enums";
import { TaskStartDatePeriod } from "Models/task";

export const APP_NAME = packageJson.name;

export const GOVLOG_COMPANY_NAME = ["gosselin govlog", "goshare"];

export const SELECTED_LANGUAGE = "Shipeezi-selectedLanguage";
export const DEFAULT_LANGUAGE = "Shipeezi-defaultLanguage";
export const SELECTED_FLAG = "Shipeezi-selectedFlag";
export const SELECTED_LANGUAGE_PREFIX = "Shipeezi-selectedLanguagePrefix";
export const LAST_ORDER_SELECTED = "Shipeezi-lastOrderSelected";

export const SELECTED_COMPANIES_IDS = "selected_companies_ids";
export const SELECTED_TASK_TYPES = "selected_task_types";

export const SELECTED_COLUMNS_ORDERS = "selected_columns_orders";
export const SELECTED_COLUMNS_QUOTES = "selected_columns_quotes";

export const USER_TOKEN = "user_token";

export const USER_PERMISSIONS = "user_permissions";

export const CURRENT_USER = "current_user";

export const CUSTOMER_PORTAL_THEME = "customer_portal_theme";

export const USER_UID = "user_uid";

export const DUMONT_TOKEN_KEY = "shipeezi_dumont_token";
export const DUMONT_DEFAULT_AGENT_ID_KEY = "shipeezi_dumont_default_agent_id";
export const DUMONT_EXTERNAL_API_KEY =
  "0a1b2c3d4e5f60718293a4b5c6d7e8f90a1b2c3d4e5f60718293a4b5c6d7e8f9";

export const USER_COMPANY = "user_company";

export const LOGIN_TIME = "login_time";

export const SESSION_TIME = "session_time";

export const IS_TERMINATED = "isTerminated";

export const LAST_PAGE = "last_page";

export const MOBILE_MAX_SIZE = 435;

export const PASSWORD_MAX_STRENGTH = 12;

export const LIMITS = [25, 50, 75, 100];

export const SESSION_HOURS = 8;

export const WARNING_SHOW_POPUP_AFTER_IN_MIN = 15;

export const INTERVAL_AFTER_ONE_MIN = 1;
export const PUBLIC_ROUTES = {
  SIGN_IN: "/signin",
  SIGN_UP: "/signup",
  FORGOT: "/forgot",
  UPDATE_PASSWORD: "/update-password",
  CONFIRM_EMAIL_ADDRESS: "/confirmemailaddress",
  APPROVE_COMPANY_TEMPORARY: "/settings/approve",
  SHIPMENT_TRACKING_CLIENT: "/shipments-tracking-client",
  SUPPLIER_ACCEPT_INVITE: "/supplier-accept-invite",
  PRIVACY_POLICY: "/privacypolicy",
  ESTIMATE_QUOTE: "/job/estimate",
  CUSTOMER_PORTAL: "/customer-portal",
  CUSTOMER_PORTAL_LOGIN: "/customer-portal/login",
  CUSTOMER_ACCEPT_INVITE: "/customer-accept-invite",
  ACCEPT_SHIPEEZI_NETWORK_INVITE: "/accept-shipeezi-network-invite",
  REJECT_SHIPEEZI_NETWORK_INVITE: "/reject-shipeezi-network-invite",
  ACCEPT_TASK_INVITE: "/accept-task-invite",
  REJECT_TASK_INVITE: "/reject-task-invite",
};

export const CUSTOMER_PORTAL_PUBLIC_ROUTES = {
  FORGOT: "/forgot",
  EMAIL_CONFIRMATION: "/email-confirmation",
};

export const PRIVATE_ROUTES = {
  CONTAINERS: "/app/containers",
  ORDERS: "/app/orders",
  ORDERS_MNT: "/app/orders-mnt",
  ORDERS_QUICK: "/app/quick-order",
  ONBOARDING: "/app/onboarding",
  SHIPMENTS: "/app/shipments",
  SHIPMENTS_MNT: "/app/shipments-mnt",
  SHIPMENTS_TRACKING_MNT: "/app/shipments-tracking-mnt",
  SHIPMENTS_TRACKING: "/app/shipments-tracking",
  PRODUCTS: "/app/products",
  PRODUCTS_MNT: "/app/products-mnt",
  DISPATCH: "/app/dispatch",
  DISPATCH_MNT: "/app/dispatch-mnt",
  ANALYTICS: "/app/analytics",
  ANALYTICS_MNT: "/app/analytics-mnt",
  MANAGE_EMAIL_SUBSCRIPTIONS: "/app/analytics/manage-email-subscriptions",
  SUPPLIERS: "/app/suppliers",
  SUPPLIERS_MNT: "/app/suppliers-mnt",
  PRODUCT_PO_SEARCH: "/app/product-po-search",
  SETTINGS: "/app/settings",
  USERS_MNT: "/app/users-mnt",
  USERS_PEOPLE_MNT: "/app/users-people-mnt",
  SUBCONTRACTORS_MNT: "/app/subcontractors-mnt",
  MEMBERS_MNT: "/app/members-mnt",
  PROFILE: "/app/profile",
  VIDEOCALL: "/app/videocall",
  QUOTES: "/app/quotes",
  QUOTES_MNT: "/app/quotes-mnt",
  SCHEDULE: "/app/schedule",
  NETWORK: "/app/network",
  NETWORK_CUSTOMER_MNT: "/app/network-customer-mnt",
  NETWORK_AGENT_MNT: "/app/network-agent-mnt",
  NETWORK_ACCOUNT_MNT: "/app/network-account-mnt",
  SETTINGS_APPROVE: "/app/settings/approve",
  ACCEPT_INVITE: "/app/accept-invite",
  BOOKINGS: "/app/bookings",
  BOOKINGS_MNT: "/app/bookings-mnt",
  NOTIFICATIONS: "/app/notifications",
  UNAUTHORIZED: "/app/unauthorized",
  BILLING: "/app/billing",
  CHAT: "/app/chat",
  MAIL: "/app/mail",
  TODO: "/app/todo",
  NOTIFICATION_CENTRE: "/app/notification/centre",
  COMMUNICATION_CENTRE: "/app/communication-centre",
  INVOICES: "/app/invoices",
  TASKS_MNT: "/app/tasks-mnt",
  OVERVIEW: "/app/overview",
  OVERVIEW_MAIN: "/app/overview/main",
  JOBS: "/app/jobs",
  DESPATCHES: "/app/despatches",
  DESPATCHES_MNT: "/app/despatches-mnt",
  ANALYTICS_OLD: "/app/analytics-old",
  MOVEMENT: "/app/movement",
  MOVEMENT_MNT: "/app/movement-mnt",
  REPORTS_OLD: "/app/reports-old",
  STORAGE_ACCOUNTS: "/app/storage-accounts",
  STORAGE_ACCOUNTS_MNT: "/app/storage-accounts-mnt",
  STORAGE_BOXES_UNITS: "/app/storage-boxes-units",
  ROUTE_PLANNER: "/app/route-planner",
  TRANSSHIPMENTS: "/app/transshipments",
  TRANSSHIPMENTS_MNT: "/app/transshipments-mnt",
  CUSTOMER_PORTAL: "/app/customer-portal",
  EQUIPMENT_MNT: "/app/settings-equipment-mnt",
  MOVING_DESPATCH: "/app/dispatch-operation",
  EXAMPLE_COMPONENTS: "/app/example-components",
  TEMPLATE_CREATE: "/app/template-create",
  LEADS: "/app/leads",
  PROPOSAL: "/app/proposal",
  CUSTOMERS: "/app/customers",
  INVOICING: "/app/invoicing",
  CREDIT_NOTES: "/app/credit-notes",
  EXPENSES: "/app/expenses",
  CLAIMS: "/app/claims",
  FINANCE: "/app/finance",
  BRANDING: "/app/branding",
  LEGAL: "/app/legal",
  SALES_APP: "/app/sales-app",
  INTEGRATIONS: "/app/integrations",
  DUMONT_AI: "/app/dumontai",
};

export const STORAGE_STATUS: Option[] = [
  { value: StorageStatus.EMPTY, name: StorageStatus.EMPTY },
  { value: StorageStatus.LOADED, name: StorageStatus.LOADED },
  { value: StorageStatus.FULL, name: StorageStatus.FULL },
];

export const LOCATION_STATUS: Option[] = [
  { value: LocationStatus.EMPTY, name: LocationStatus.EMPTY },
  { value: LocationStatus.IN_USE, name: LocationStatus.IN_USE },
];

export const TYPE_OF_USER: Option[] = [
  { value: UserTypes.ADMIN, name: UserTypes.ADMIN },
  { value: UserTypes.STAFF, name: UserTypes.STAFF },
];

export const TYPE_OF_USER_MOVING: Option[] = [
  { value: UserTypes.ADMIN, name: UserTypes.ADMIN },
  { value: UserTypes.STAFF, name: UserTypes.STAFF },
  { value: UserTypes.OPERATIONS, name: UserTypes.OPERATIONS },
  { value: UserTypes.SALES, name: UserTypes.SALES },
  { value: UserTypes.MOVING_WAREHOUSE, name: UserTypes.MOVING_WAREHOUSE },
  { value: UserTypes.AGENT, name: UserTypes.AGENT },
];

export const TYPE_OF_USER_FM: Option[] = [
  ...TYPE_OF_USER,
  { value: UserTypes.USER, name: UserTypes.USER },
  { value: UserTypes.WAREHOUSE, name: UserTypes.WAREHOUSE },
  { value: UserTypes.DRIVER, name: UserTypes.DRIVER },
];

export const TYPE_OF_TRANSSHIPMENT: Option[] = [
  { value: TransshipmentStatus.PLANNED, name: TransshipmentStatus.PLANNED },
  { value: TransshipmentStatus.UNPLANNED, name: TransshipmentStatus.UNPLANNED },
];

export const ROUTES = [
  {
    path: "Edit-Equipment",
  },
  {
    path: "New_Equipment",
  },
  {
    path: "overview",
  },
  {
    path: "projects",
  },
  {
    path: "projects-mnt",
  },
  {
    path: "orders",
  },
  {
    path: "orders-mnt",
  },
  {
    path: "quick-order",
  },
  {
    path: "shipments",
  },
  {
    path: "shipments-mnt",
  },
  {
    path: "products",
  },
  {
    path: "products-mnt",
  },
  {
    path: "dispatch",
  },
  {
    path: "dispatch-mnt",
  },
  {
    path: "despatches",
  },
  {
    path: "despatches-mnt",
  },
  {
    path: "containers",
  },
  {
    path: "analytics",
  },
  {
    path: "suppliers",
  },
  {
    path: "suppliers-mnt",
  },
  {
    path: "places-mnt",
  },
  {
    path: "product-po-search",
  },
  {
    path: "settings",
  },
  {
    path: "users-mnt",
  },
  {
    path: "users-people-mnt",
  },
  {
    path: "symbols-mnt",
  },
  {
    path: "items-types-mnt",
  },
  {
    path: "items-descriptions-mnt",
  },
  {
    path: "fleets-mnt",
  },
  {
    path: "staffs-mnt",
  },
  {
    path: "services-mnt",
  },
  {
    path: "roles-people-mnt",
  },

  {
    path: "quotes",
  },
  {
    path: "quotes-mnt",
  },
  {
    path: "tasks-mnt",
  },
  {
    path: "videocall",
  },
  {
    path: "jobs",
  },
  {
    path: "jobs-mnt",
  },
  {
    path: "profile",
  },
  {
    path: "onboarding",
  },
  {
    path: "unauthorized",
  },
  {
    path: "bookings",
  },
  {
    path: "create-subcontractor",
  },
  {
    path: "edit-subcontractor",
  },
];

// Tooltip Styles
export const tooltipStyle = {
  backgroundColor: "rgba(0,0,0,0.6)",
  border: "1px solid rgba(0,0,0,0.6)",
  borderRadius: "5px",
};

export const tooltipTextStyle = {
  color: "#FFF",
  fontSize: "12px",
  paddingTop: "5px",
  paddingBottom: "5px",
  lineHeight: "1",
};

export const AppConfig = {
  appLogo: "https://shipeezi-images.s3.ap-southeast-2.amazonaws.com/shipeezi-logo.png",
  appLogo2: "https://shipeezi-images.s3.ap-southeast-2.amazonaws.com/shipeezi-white-logo.png",
  brandName: "Shipeezi", // Brand Name
  navCollapsed: false, // Sidebar collapse
  darkMode: false, // Dark Mode
  boxLayout: false, // Box Layout
  rtlLayout: false, // RTL Layout
  miniSidebar: true, // Mini Sidebar
  enableSidebarBackgroundImage: true, // Enable Sidebar Background Image
  // sidebarImage: require('Assets/img/sidebar-5.png'),     // Select sidebar image
  isDarkSidenav: true, // Set true to dark sidebar
  enableThemeOptions: false, // Enable Theme Options
  locale: {
    languageId: "english",
    locale: "en",
    name: "English",
    icon: "en",
  },
  enableUserTour: false, // Enable / Disable User Tour
  copyRightText: `Shipeezi © ${new Date().getFullYear()} All Rights Reserved.`, // Copy Right Text
  // light theme colors
  themeColors: {
    primary: "#5D92F4",
    secondary: "#677080",
    success: "#00D014",
    danger: "#FF3739",
    warning: "#FFB70F",
    info: "#00D0BD",
    dark: "#464D69",
    default: "#FAFAFA",
    greyLighten: "#A5A7B2",
    grey: "#677080",
    white: "#FFFFFF",
    purple: "#896BD6",
    yellow: "#D46B08",
  },
  // dark theme colors
  darkThemeColors: {
    darkBgColor: "#424242",
  },
};

export const ChartConfig = {
  color: {
    primary: AppConfig.themeColors.primary,
    info: AppConfig.themeColors.info,
    warning: AppConfig.themeColors.warning,
    danger: AppConfig.themeColors.danger,
    success: AppConfig.themeColors.success,
    default: "#DEE4E8",
    purple: AppConfig.themeColors.purple,
    secondary: AppConfig.themeColors.secondary,
    yellow: AppConfig.themeColors.yellow,
    white: "#FFFFFF",
    dark: AppConfig.themeColors.white,
    greyLighten: AppConfig.themeColors.greyLighten,
    grey: AppConfig.themeColors.grey,
  },
  legendFontColor: "#AAAEB3", // only works on react chart js 2
  chartGridColor: "#EAEAEA",
  axesColor: "#657786",
  shadowColor: "rgba(0,0,0,0.6)",
};

export const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints["video"] = {
  width: 1280,
  height: 720,
  frameRate: 24,
};

export const AUDIO_LEVEL_THRESHOLD = 200;

export const LOG_LEVEL = process.env.NODE_ENV === "development" ? "debug" : "error";

export const DEFAULT_EDGES: Edge[] = ["roaming"];

export const DEFAULT_CODEC_PREFERENCES: Call.Codec[] = [Call.Codec.PCMU, Call.Codec.Opus];

export const SELECTED_AUDIO_INPUT_KEY = "Shipeezi-selectedAudioInput";
export const SELECTED_AUDIO_OUTPUT_KEY = "Shipeezi-selectedAudioOutput";
export const SELECTED_VIDEO_INPUT_KEY = "Shipeezi-selectedVideoInput";

export const AUDIO_LEVEL_STANDARD_DEVIATION_THRESHOLD = AUDIO_LEVEL_THRESHOLD * 0.05; // 5% threshold

export const INPUT_TEST_DURATION = 20000;

export const RECORD_DURATION = 4000;

export const DataTrackMessage = {
  CUSTOMER_FINISHED: "CUSTOMER_FINISHED",
  CUSTOMER_REFRESH_SCREEN: "CUSTOMER_REFRESH_SCREEN",
  CUSTOMER_ALREADY_IN_ROOM: "CUSTOMER_ALREADY_IN_ROOM",
  CUSTOMER_WINDOW_VISIBLE: "CUSTOMER_WINDOW_VISIBLE",
  CUSTOMER_WINDOW_HIDDEN: "CUSTOMER_WINDOW_HIDDEN",
  CUSTOMER_ENABLE_VIDEO: "CUSTOMER_ENABLE_VIDEO",
  CUSTOMER_DISABLE_VIDEO: "CUSTOMER_DISABLE_VIDEO",
  CUSTOMER_ALLOWED_RECORDING: "CUSTOMER_ALLOWED_RECORDING",
  CUSTOMER_NOT_ALLOWED_RECORDING: "CUSTOMER_NOT_ALLOWED_RECORDING",

  SHIPEEZI_FINISHED: "SHIPEEZI_FINISHED",
  SHIPEEZI_REFRESH_SCREEN: "SHIPEEZI_REFRESH_SCREEN",

  REQUEST_ENTER_ROOM: "REQUEST_ENTER_ROOM",
  REQUEST_ENTER_ROOM_RECEIVED: "REQUEST_ENTER_ROOM_RECEIVED",
  ALLOW_REQUEST_ENTER_ROOM: "ALLOW_REQUEST_ENTER_ROOM",
  NOT_ALLOW_REQUEST_ENTER_ROOM: "NOT_ALLOW_REQUEST_ENTER_ROOM",
};

export const edgeNameMap = {
  sydney: "Sydney",
  "sao-paulo": "Sao Paulo",
  dublin: "Dublin",
  frankfurt: "Frankfurt",
  tokyo: "Tokyo",
  singapore: "Singapore",
  ashburn: "Ashburn",
  roaming: "Roaming",
  "ashburn-ix": "Ashburn IX",
  "san-jose-ix": "San Jose IX",
  "london-ix": "London IX",
  "frankfurt-ix": "Frankfurt IX",
  "singapore-ix": "Singapore IX",
};

export const templateTags = {
  customer: {
    "@customer.type": "Type",
    "@customer.firstname": "First Name",
    "@customer.lastname": "Last Name",
    "@customer.sms": "SMS",
    "@customer.phone": "Phone",
    "@customer.destinationMobile": "Destination Mobile",
    "@customer.address": "Address",
    "@costumer.companyName": "Company Name",
  },
  quote: {
    "@quote.type": "Quote Type",
    "@quote.reference": "Reference",
    "@quote.branchOrigin": "Branch Origin",
    "@quote.branchDestination": "Branch Destination",
    "@quote.status": "Status",
    "@quote.consultant": "Consultant",
    "@quote.code": "Code",
    "@quote.manager": "Manager",
    "@quote.leadSourceFrom": "Lead source from",
    "@quote.mode": "Mode",
    "@quote.pickupAccess": "Pickup Access",
    "@quote.deliveryAccess": "Delivery Access",
    "@quote.allowance": "Allowance",
    "@quote.secondReference": "Second Reference",
  },
  order: {
    "@order.type": "Order Type",
    "@order.reference": "Reference",
    "@order.branchOrigin": "Branch Origin",
    "@order.branchDestination": "Branch Destination",
    "@order.status": "Status",
    "@order.consultant": "Consultant",
    "@order.code": "Code",
    "@order.manager": "Manager",
    "@order.leadSourceFrom": "Lead source from",
    "@order.mode": "Mode",
    "@order.pickupAccess": "Pickup Access",
    "@order.deliveryAccess": "Delivery Access",
    "@order.allowance": "Allowance",
    "@order.secondReference": "Second Reference",
  },
  company: {
    "@business.type": "Business Name",
    "@business.address": "Address",
    "@business.businessRegistrationNumber": "Business Registration Number",
    "@business.phone": "Phone",
    "@business.mainSMSAddress": "Main sms address",
    "@business.website": "Website",
  },
  shipment: {
    "@shipment.containerId": "Shipment #",
    "@shipment.containerNumbers": "Container #",
    "@shipment.shipmentType": "Type",
    "@shipment.shipper": "Shipper",
    "@shipment.carrier": "Carrier",
    "@shipment.containerSize": "Container Size",
    "@shipment.seal": "Seal",
    "@shipment.bookingNo": "Booking Reference",
    "@shipment.vessel": "Vessel",
    "@shipment.billOfLanding": "Bill of Landing",
    "@shipment.voyage": "Voyage",
    "@shipment.commodity": "Commodity",
    "@shipment.originAgent.name": "Origin Agent Name",
    "@shipment.originAgent.email": "Origin Agent Email",
    "@shipment.originAgent.mobile": "Origin Agent Mobile",
    "@shipment.destinationAgent.name": "Destination Agent Name",
    "@shipment.destinationAgent.email": "Destination Agent Email",
    "@shipment.destinationAgent.mobile": "Destination Agent Mobile",
    "@shipment.statusShipment": "Shipment Status",
    "@shipment.etaFinalPort": "ETA",
    "@shipment.shipmentTracking.finalPortPredictiveArrival": "ETD",
    "@shipment.carrierScac": "Carrier SCAC",
  },
  user: {
    "@user.firstName": "First Name",
    "@user.lastName": "Last Name",
    "@user.fullName": "Full Name",
    "@user.email": "Email",
    "@user.phone": "Phone",
    "@user.company.name": "Company Name",
    "@user.company.address": "Company Address",
    "@user.company.phone": "Company Phone",
  },
  task: {
    "@task.type": "Task Type",
    "@task.reference": "Task Reference",
    "@task.status": "Task Status",
    "@task.startDate": "Start Date",
    "@task.finishDate": "Finish Date",
  },
  videoSurvey: {
    "@videoSurvey.roomName": "Room Name",
    "@videoSurvey.roomLink": "Room Link",
    "@videoSurvey.qrCode": "QR Code",
    "@videoSurvey.taskType": "Task Type",
    "@videoSurvey.taskReference": "Task Reference",
  },
};

// TODO: This is a local list because we are waiting for maersk to explain the difference between DC_CODES, later this will come from API
export const WholesaleList = [
  1000, 7112, 7113, 7522, 7523, 7525, 8015, 8016, 8096, 8106, 8123, 8125, 8144, 8146, 8154, 8159,
  8160, 8174, 8182, 8183, 8184, 8185, 8186, 8193, 8197, 8198, 8199, 8200, 8253, 8268, 8269, 8270,
  8271, 8272, 8273, 8277, 8293, 8649, 8651, 8652, 8683, 8684, 8735, 8736, 8747, 8754, 8648, 8282,
];

export const LINKS = {
  aboutUs: "https://shipeezi.com/about",
  contact: "https://shipeezi.com/contact",
  termsOfUse: "https://shipeezi.com/legal",
  privacyPolicy: "https://shipeezi.com/legal",
};

export const SHIPEEZI_MOVING_DEV = "Shipeezi Moving Dev";

export const MonthsOptions = [
  {
    label: Months.JANUARY,
    value: "1",
  },
  {
    label: Months.FEBRUARY,
    value: "2",
  },
  {
    label: Months.MARCH,
    value: "3",
  },
  {
    label: Months.APRIL,
    value: "4",
  },
  {
    label: Months.MAY,
    value: "5",
  },
  {
    label: Months.JUNE,
    value: "6",
  },
  {
    label: Months.JULY,
    value: "7",
  },
  {
    label: Months.AUGUST,
    value: "8",
  },
  {
    label: Months.SEPTEMBER,
    value: "9",
  },
  {
    label: Months.OCTOBER,
    value: "10",
  },
  {
    label: Months.NOVEMBER,
    value: "11",
  },
  {
    label: Months.DECEMBER,
    value: "12",
  },
];

export const DEFAULTS_COMMODITIES = ["Household effects", "Used personal"];

export enum DefaultDateOptionsColumn {
  DATE = "date",
  DATE_RANGE = "dateRange",
  HIDE_DATE_SELECTOR = "hideDateSelector",
}

export enum DefaultPeriodOptionsColumn {
  LAST_DAY = "lastDay",
  LAST_WEEK = "lastWeek",
  LAST_15_DAYS = "last15Days",
  LAST_MONTH = "lastMonth",
  LAST_QUARTER = "lastQuarter",
  LAST_YEAR = "lastYear",
  LIFETIME = "lifetime",
  CUSTOM_PERIOD = "customPeriod",
  CUSTOM_DATE = "customDate",
}

export const SimplePeriodOptions = [
  {
    name: "Custom period",
    column: DefaultPeriodOptionsColumn.CUSTOM_PERIOD,
    type: DefaultDateOptionsColumn.DATE_RANGE,
  },
  {
    name: "Custom date",
    column: DefaultPeriodOptionsColumn.CUSTOM_DATE,
    type: DefaultDateOptionsColumn.DATE,
  },
];

export const IGNORE_SUB_DOMAINS = ["work", "test", "demo", "app"];

export const FLEET = "fleet";

export const LIFTVAN = "Liftvan";

export const SUPPLY_CHAIN_OVERVIEW_CONFIGURE_STORAGE_KEY = "supplyChainOverviewConfigure";
export const SUPPLY_CHAIN_OVERVIEW_VERSION_KEY = "supplyChainOverviewVersion";
export const SUPPLY_CHAIN_OVERVIEW_LAST_TAB = "supplyChainOverviewLastTab";
export const SUPPLY_CHAIN_OVERVIEW_LAST_PERIOD = "supplyChainOverviewLastPeriod";
export const SUPPLY_CHAIN_OVERVIEW_LAST_CUSTOM_DATE = "supplyChainOverviewLastCustomDate";
export const SUPPLY_CHAIN_OVERVIEW_LAST_CUSTOM_PERIOD = "supplyChainOverviewLastCustomPeriod";

export const OverviewChartColors = [
  colors.success500,
  colors.brandBlue500,
  colors.purple600,
  colors.blueLight500,
  colors.warning600,
  colors.error600,
  colors.indigo500,
  colors.gray300,
];

export const SUPPLY_CHAIN_OVERVIEW_LAYOUTS_DEFAULT = {
  containers: [
    { h: 1, i: "inbound", isResizable: false, minH: 1, minW: 1, w: 1, x: 0, y: 0 },
    { h: 1, i: "atPort", isResizable: false, minH: 1, minW: 1, w: 1, x: 1, y: 0 },
    { h: 1, i: "atDC", isResizable: false, minH: 1, minW: 1, w: 1, x: 2, y: 0 },
    { h: 2, i: "containerDistributionByDestination", minH: 2, minW: 2, w: 6, x: 0, y: 1 },
    { h: 2, i: "containersStatuses", minH: 2, minW: 2, w: 2, x: 0, y: 3 },
    { h: 2, i: "containersByArrivalDate", minH: 2, minW: 2, w: 4, x: 2, y: 3 },
  ],
  orders: [
    { h: 1, i: "pendingPurchaseOrders", isResizable: false, minH: 1, minW: 2, w: 2, x: 0, y: 0 },
    { h: 1, i: "shipByDate", isResizable: false, minH: 1, minW: 2, w: 2, x: 2, y: 0 },
    { h: 2, i: "poStatuses", minH: 2, minW: 2, w: 3, x: 0, y: 1 },
    { h: 2, i: "lastReceivedOrders", minH: 2, minW: 2, w: 3, x: 3, y: 1 },
    { h: 3, i: "poConfirmedVSPoReceived", minH: 2, minW: 2, w: 6, x: 0, y: 3 },
  ],
  products: [
    { h: 3, i: "productsOrigin", minH: 2, minW: 2, w: 6, x: 0, y: 0 },
    { h: 2, i: "mostRequestedProducts", minH: 2, minW: 2, w: 3, x: 0, y: 3 },
    { h: 2, i: "productsRunningOutOfStock", minH: 2, minW: 2, w: 3, x: 3, y: 3 },
  ],
  shipments: [
    { h: 3, i: "shipmentsTracked", minH: 2, minW: 2, w: 6, x: 0, y: 0 },
    { h: 2, i: "shipmentsPerDate", minH: 2, minW: 2, w: 3, x: 0, y: 3 },
    { h: 2, i: "shipmentStatuses", minH: 2, minW: 2, w: 3, x: 3, y: 3 },
  ],
};

export const PURCHASE_ORDERS_STATUS_COLORS: { [key: string]: any } = {
  [OrderStatus.ASSIGNED]: { background: colors.pink100, text: colors.pink600 },
  [OrderStatus.CANCELLED]: { background: colors.error100, text: colors.error500 },
  [OrderStatus.CLOSED_FOR_INVOICING]: { background: colors.warning100, text: colors.warning600 },
  [OrderStatus.CLOSED_FOR_RECEIVING]: { background: colors.purple200, text: colors.purple700 },
  [OrderStatus.CONFIRMED]: { background: colors.success100, text: colors.success500 },
  [OrderStatus.FULFILLED]: { background: colors.gray100, text: colors.gray700 },
  [OrderStatus.LOADED]: { background: colors.indigo100, text: colors.indigo600 },
  [OrderStatus.READY_TO_SHIP]: { background: colors.blueLight100, text: colors.blueLight600 },
  [OrderStatus.RECEIVED]: { background: colors.purple100, text: colors.purple600 },
};

export const SHIPMENT_TRACKING_STATUS_COLORS: { [key: string]: any } = {
  [ShipmentTrackingStatus.ARRIVAL_AT_TRANSHIPMENT_PORT]: {
    background: colors.blue100,
    text: colors.blue500,
  },
  [ShipmentTrackingStatus.ARRIVED_AT_PORT_OR_DISCHARGE]: {
    background: colors.blue100,
    text: colors.blue600,
  },
  [ShipmentTrackingStatus.BOOKED]: {
    background: colors.blueLight100,
    text: colors.blueLight600,
  },
  [ShipmentTrackingStatus.COLLECTED_FROM_SHIPPER]: {
    background: colors.indigo100,
    text: colors.indigo600,
  },
  [ShipmentTrackingStatus.DRAFT]: {
    background: colors.gray100,
    text: colors.gray500,
  },
  [ShipmentTrackingStatus.LEFT_THE_DESTINATION_PORT]: {
    background: colors.blueLight100,
    text: colors.blueLight900,
  },
  [ShipmentTrackingStatus.NOT_ARRIVED_AT_PORT_OF_LOAD]: {
    background: colors.error100,
    text: colors.error600,
  },
  [ShipmentTrackingStatus.SHIPMENT_COMPLETED]: {
    background: colors.success100,
    text: colors.success600,
  },
  [ShipmentTrackingStatus.SHIPPED_ON_BOARD_AT_TRANSHIPMENT_PORT]: {
    background: colors.pink100,
    text: colors.pink900,
  },
  [ShipmentTrackingStatus.SHIPPED_ON_BOARD]: {
    background: colors.pink100,
    text: colors.pink600,
  },
  [ShipmentTrackingStatus.TRACKING_NOT_AVAILABLE]: {
    background: colors.gray100,
    text: colors.gray900,
  },
  [ShipmentTrackingStatus.UNDERWAY_TO_A_TRANSHIPMENT_PORT]: {
    background: colors.purple100,
    text: colors.purple600,
  },
  [ShipmentTrackingStatus.UNDERWAY]: {
    background: colors.purple100,
    text: colors.purple800,
  },
  [ShipmentTrackingStatus.WAITING_AT_DESTINATION_PORT]: {
    background: colors.warning100,
    text: colors.warning500,
  },
  [ShipmentTrackingStatus.WAITING_AT_PORT_OF_LOAD]: {
    background: colors.warning100,
    text: colors.warning900,
  },
  [ShipmentTrackingStatus.WAITING_AT_TRANSHIPMENT_PORT]: {
    background: colors.warning100,
    text: colors.warning700,
  },
  [ShipmentTrackingStatus.WAITING_FOR_UPDATE]: {
    background: colors.gray100,
    text: colors.gray700,
  },
};

// 1048576 represents 1mb
export const ONE_MB = 1048576;
export const TWO_MB = 2 * 1024 * 1024;

export const EMPTY_CHARACTER = "—";

export const PERIOD_BUFFER_TIME = {
  [TaskStartDatePeriod.MORNING]: { hours: 6 },
  [TaskStartDatePeriod.AFTERNOON]: { hours: 6 },
  [TaskStartDatePeriod.EVENING]: { hours: 6 },
  [TaskStartDatePeriod.FULL_DAY]: { hours: 12 },
  [TaskStartDatePeriod.CUSTOM]: { hours: 1 },
  [TaskStartDatePeriod.MULTI_DAY]: { days: 1 },
  [TaskStartDatePeriod.VARIABLE_TIME]: { days: 1 },
  [TaskStartDatePeriod.FIXED_TIME]: { days: 1 },
};
export const GO_SHARE_COMPANY_IDS = [587, 459, 621]; // Gosselin GovLog, Goshare

export const MOVING_COMPANY_AGENT_SIGN_IN_SELECT = "moving_company_agent_sign_in_select";
export const GOSSELIN_MOVING_COMPANY_IDS = [586, 442, 611];
export const COMPANY_BRANDING_ENABLED_IN_PRODUCTION: number[] = [621, 459, 587]; // Gosselin demo - military | GovLog Old | GovLog Military

export const MILITARY_REPORTS_NAMES = [ReportName.INVENTORY_CONDITION, ReportName.PROPERTY_DAMAGE]

export const POSITION_MENU_MV = {
  Dashboard: {
    Overview: {},
  },
  Sales: {
    Leads: {},
    Quote: {},
    Proposal: {},
    Contacts: {
      Customers: {},
      Suppliers: {},
      Subcontractors: {},
    },
    Invoicing: {},
    CreditNotes: {},
    Expenses: {},
  },
  Operations: {
    Orders: {},
    Dispatch: {},
    Bookings: {},
    Shipments: {},
    Claims: {},
  },
  Warehousing: {
    "Storage Box And Unit": {},
    Movement: {},
    Transshipment: {},
    "Storage Accounts": {},
  },
  Reports: {},
  Network: {
    Customers: {},
    Agents: {},
    Accounts: {},
  },
  Settings: {
    Company: {},
    People: {},
    Resources: {},
    Templates: {},
    Configurations: {},
  },
};

export const POSITION_MENU_SP = {
  Dashboard: {
    Overview: {},
    Widgets: {},
    Stats: {},
  },
  Operations: {
    Orders: {},
    Booking: {},
  },
  Invoices: {},
  Reports: {
    Favorites: {},
    Business: {},
    Operations: {},
  },
  Network: {
    Customers: {},
    Suppliers: {},
  },
  Settings: {
    Company: {},
    People: {},
    Configurations: {},
  },
};

export const RESOURCE_HAVE_VIEW_FEATURE = [ResourceName.DISPATCH, ResourceName.SHIPMENTS];

export const RESOURCE_HAVE_MASTER_DATA = [
  ResourceName.STORAGE_BOX_AND_UNIT,
  ResourceName.MOVEMENT,
  ResourceName.TRANSSHIPMENT,
  ResourceName.STORAGE_ACCOUNTS,
  ResourceName.ANALYTICS,
];

export const DESTINATION_TASK_TYPES = [
  TaskType.ASSISTANCE_DESTINATION,
  TaskType.ASSISTANCE_AT_DESTINATION,
  TaskType.COLLECTION_DEBRIS,
  TaskType.COLLECTION_PAPERS_DEBRIS_DESTINATION,
  TaskType.DELIVERY,
  TaskType.OFFER,
  TaskType.DELIVERY_PAPERS_DESTINATION,
  TaskType.PARKING_SIGNS_DESTINATION,
  TaskType.PICKUP_PARKING_SIGNS_DESTINATION,
  TaskType.PLACING_PARKING_SIGNS_DESTINATION,
  TaskType.PLACING_PARKING_SIGNS_DESTINATION,
  TaskType.ACCESS_CHECK_DESTINATION,
  TaskType.UNPACK,
];

export const MOVING_AGENT_COMPANY_PROFILE_ID = 6;
